// 用户资产变更单-主页
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :type="editViewType" :processId="processId" :_dataId.sync="dataId"
                  :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">

        <div>
          <vxe-grid show-overflow :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle"
                    :checkbox-config="{ labelField: '', highlight: true, reserve: true, range: true }">

            <template #form>
              <div class="clearfix screen-btns" style=" padding-bottom: 6px;">
                <div class="fl">
                  <vxe-button v-if="addButton" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog(0, 'add')">新增
                  </vxe-button>
                  <vxe-button v-if="wkAssetTransferExport" status="primary" class="button-sty" icon="el-icon-top" @click="doExcle">导出
                  </vxe-button>
                </div>
                <div class="fr" style="display: flex;">
                  <vxe-button status="warning" icon="el-icon-search" style="margin: 0 1px;" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <el-collapse-transition name="fade">

                <vxe-form ref="form" class="screen-box" title-width="5vw" title-align="right" :data="formData"
                          @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="申请单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.billNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="申请类型:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.applyType" filterable clearable style="width:9vw!important ;">
                        <el-option value="1" label="转移"></el-option>
                        <el-option value="2" label="失效"></el-option>
                      </el-select>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="工单号:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.orderNo" size="small" style="width:9vw ;" clearable />
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="创建时间:" field="name">
                    <template v-slot>
                      <el-date-picker style="width: 16vw;" v-model="formData.createDate" type="daterange" align="right"
                                      unlink-panels range-separator="-" start-placeholder="开始日期"
                                      end-placeholder="结束日期"
                                      :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                      </el-date-picker>
                    </template>
                  </vxe-form-item>


                </vxe-form>
              </el-collapse-transition>

              <div class="goodsStatus">
                <div v-for="(item, index) in goodsStatusList" :key="index">
                  <div :class="{
                    btnGoodsStatusBt1: goodsStatusIndex == index,
                    btnGoodsStatusBt: goodsStatusIndex != index
                  }" @click="changeGoodsStatus(item, index)">
                    <span>{{ item.name }}</span> <span class="num_color" v-if="item.name !== '所有'">{{ item.num }}</span>
                  </div>
                </div>
              </div>

            </template>

            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>

            <!-- <template #stat="{ row }">
              <span v-if="row.stat == 1">制单</span>
              <span v-else-if="row.stat == 2">审核中</span>
              <span v-else-if="row.stat == 5">已审核</span>
              <span v-else-if="row.stat == 6">驳回</span>
              <span v-else-if="row.stat == 99">取消</span>
              <span v-else></span>
            </template> -->

            <template #option="{ row }">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row, 'edit')">
                <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                  <i class="el-icon-edit" />
                </el-tooltip>
              </a>

              <el-dropdown @command="handleCommand($event, row)">
                <span class="el-dropdown-link">
                  <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a" v-if="(row.stat == 1)&&submitButton && !row.processId">提交</el-dropdown-item>
                  <el-dropdown-item command="b" v-if="row.stat == 2&&checkButton && !row.processId">审核</el-dropdown-item>
                  <el-dropdown-item command="c" v-if="row.stat == 2&&rejectButton && !row.processId">驳回</el-dropdown-item>
                  <el-dropdown-item command="d" v-if="(row.stat == 1||row.stat == 6)&&cancelButton && !row.processId">取消</el-dropdown-item>
                  <el-dropdown-item command="e" v-if="row.stat == 1 && !row.processId">启动流程</el-dropdown-item>
                  <el-dropdown-item command="f" v-if="row.processId!=null">查看流程</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <checkDialog v-if="showCheckDialog" @commit="checkCommit" :visiable.sync="showCheckDialog" :dataId="this.currentRow.id"
                 :billNo="this.currentRow.billNo" multi="true" />

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showPicDialog"
      title="流程图">
      <img v-if="showPicDialog" :src="actPicUrl" width="100%">
    </el-dialog>

  </div>
</template>

<script>
import editView from './edit.vue';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import { mapGetters } from "vuex";
import api from "@/api/projectApi";
import SiteSearch from "@/components/formItem/siteSearch.vue";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import checkDialog from "@/views/expense/asset/transfer/check.vue";

export default {
  name: 'assetTransferIndex',
  inject: ['reload'],
  components: { checkDialog, SiteSearch, editView, pager, },
  data() {
    return {
      actPicUrl:"",
      showPicDialog:false,
      addButton:  false,
      editButton:  false,
      wkAssetTransferExport: false,
      showCheckDialog:false,

      total: 0,
      editViewType: null,
      brandOptions: [],
      orderTypeOptions: [],
      serviceTypeOption: [],
      dispatchStatOptions: [],

      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量

        billNo: null,
        orderNo: null,

        stat: 1,
        orgId: null,
        siteId: null,
        applyType: null,
        createTimeBegin: null,
        createTimeEnd: null,
      },

      formData: {
        billNo: null,
        orderNo: null,
        barcode: null,
        itemCode: null,

        stat: 1,
        applyType: null,
        createDate: null,
        createTimeBegin: null,
        createTimeEnd: null,
      },

      sitePromptList: [],
      dialogVisible: false,
      dialogMsg: null,
      currentRow: null,
      statName: null,
      goodsStatusList: [ //循环列表
        { name: "制单", num: 0 },
        { name: "审核中", num: 0 },
        { name: "已审核", num: 0 },
        { name: "驳回", num: 0 },
        { name: "全部", num: 0 },
      ],
      goodsStatusItem: "",//获取点击的元素名称
      goodsStatusIndex: 0,//:class做判断用，默认选中第一个

      input: '',
      showPreconditionDialog: false,
      //  取消执行
      showPreconditionDialog2: false,


      pickerOptions: {

        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      activeName: 'second',
      dataId: 0,

      vxeOption: {},
      pageSizes: [10, 20, 100],
      showEdit: false,
      columns: [
        { type: 'checkbox', width: 30, title: '', resizable: false, fixed: 'left' },
        { width: 100, field: 'status', fixed: 'right', title: '操作', showOverflow: true, slots: { default: 'option' } },
        {
          title: '申请单号', field: 'billNo', width: 180, slots: {
            // 使用 JSX 渲染
            default: ({ row }) => {
              return [
                <span style="color: blue"
                      onClick={($event) => this.showInfo(row, $event)}>{row.billNo}</span>
              ]
            }
          }
        },
        {
          title: '状态', field: 'stat', width: 125, slots: {
            default: ({ row }) => {
              if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>制单</span>
                  </div>
                ];
              } else if (row.stat == 2) {
                return [
                  <div class="txt-status neutral">
                    <span>审核中</span>
                  </div>
                ];
              } else if (row.stat == 5) {
                return [
                  <div class="txt-status">
                    <span>已审核</span>
                  </div>
                ];
              } else if (row.stat == 6) {
                return [
                  <div class="txt-status disable">
                    <span>驳回</span>
                  </div>
                ];
              } else if (row.stat == 99) {
                return [
                  <div class="txt-status disable">
                    <span>取消</span>
                  </div>
                ];
              }
            }
          }
        },
        { title: '申请类型', field: 'applyType', width: 100, slots: {
            default: ({ row }) => {
              if (row.applyType == 1) {
                return [
                  <div class="txt-status">
                    <span>转移</span>
                  </div>
                ];
              } else if (row.applyType == 2) {
                return [
                  <div class="txt-status">
                    <span>失效</span>
                  </div>
                ];
              }
            }
          }
          },
        { title: '工单单号', field: 'orderNo', width: 130, },
        { title: '产品条码', field: 'barcode', width: 130, },
        { title: '档案号', field: 'profileNo', width: 130, },
        { title: '转移的档案号', field: 'transferProfileNo', width: 130, },
        { title: '创建时间', field: 'createTime', width: 150, },
        { title: '创建人', field: 'createBy', width: 80, },


      ]
    };
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    'formData.createDate': {
      handler(newVal, oldVal) {
        if (newVal != null && newVal.length !== 0) {
          this.formData.createTimeBegin = newVal[0]
          this.formData.createTimeEnd = newVal[1]
        } else if (newVal == null) {
          this.formData.createTimeBegin = null
          this.formData.createTimeEnd = null
        }
      },
      deep: true,
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.getTableData()
    //   }
    // },

  },
  created() {
    this.addButton = this.permissions["wkAssetTransferAdd"];
    this.editButton = this.permissions["wkAssetTransferEdit"];
    this.wkAssetTransferExport = this.permissions["wkAssetTransferExport"];
    this.submitButton= this.permissions["wkAssetTransferSubmit"]; //提交
    this.checkButton= this.permissions["wkAssetTransferCheck"]; //审核
    this.rejectButton= this.permissions["wkAssetTransferReject"]; //驳回
    this.cancelButton= this.permissions["wkAssetTransferCancel"]; //取消
  },

  mounted() {
    this.initSearchDate()
    this.loadTabOption()
  },

  methods: {
    toFilterData() {
      this.searchEvent();
    },
    // tab也切换为列表页
    goBackIndex() {
      this.activeName = 'second'
      this.showEdit = false
      this.flushed()
    },
    confirm() {
      this.$mask.open()

      this.$http({
        url: api.wkAssetTransfer.confirmDataUrl,
        method: 'post',
        data: {
          id: this.currentRow.id,
          statName: this.statName
        }
      }).then(res => {
        //this.$message.success('操作成功');
        if (res.data.type == "success") {
          this.$message({message: res.data.content, type: 'success'});

        } else {
          this.$message({message: res.data.content, type: 'warning'});
        }
        this.flushed()
      })
      this.dialogVisible = false
      this.$mask.close()

    },
    flushed() {
      this.$objCopy(this.formData, this.requestParam)
      this.loadTabOption()

      this.$refs['table-m1'].commitProxy('reload');
    },

    // 初始化搜索时间
    initSearchDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.formData.createDate = [start, end]
      this.requestParam.createTimeBegin = start
      this.requestParam.createTimeEnd = end
    },

    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'get',
        data: { userName: queryStr }
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({ value: item.userName, id: item.id })
        })
        callback(temp)
      })
    },


    // 加载tab数据
    loadTabOption() {
      console.log("this.requestParam",this.requestParam)
      this.$http({
        url: api.wkAssetTransfer.getCountUrl,
        method: 'post',
        data: this.requestParam
      }).then(res => {
        this.goodsStatusList = res.data.data
        this.goodsStatusList.forEach((item,index) =>{
          if(item.num === null){
            item.num = 0
          }
        })
      })
    },

    // 选中的按钮
    changeGoodsStatus(item, index) {
      this.goodsStatusItem = item.name;//获取点击的元素
      this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
      let s = null
      if (item.name === '制单') {
        s = 1
      } else if (item.name === '审核中') {
        s = 2
      } else if (item.name === '已审核') {
        s = 5
      } else if (item.name === '驳回') {
        s = 6
      }
      this.requestParam.stat = s
      this.formData.stat = s
      this.flushed()

    },


    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.wkAssetTransfer.getPageDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 操作
    handleCommand(command, row) {
      this.currentRow = row
      console.log(command, row, "command,b的值");
      if (command === 'a') { //提交
        //this.openEditDialog(row.id, 'submit')
        this.dialogMsg = '确定提交吗？'
        this.statName = '提交'
        this.dialogVisible = true
      } else if (command === 'b') { //审核
        //this.openEditDialog(row.id, 'check')
        /*this.dialogMsg = '确定审核吗？'
        this.statName = '审核'
        this.dialogVisible = true*/
        this.showCheckDialog = true
      } else if (command === 'c') { //驳回
        //this.openEditDialog(row.id, 'reject')
        this.dialogMsg = '确定驳回吗？'
        this.statName = '驳回'
        this.dialogVisible = true
      } else if (command === 'd') { //取消
        //this.openEditDialog(row.id, 'cancel')
        this.dialogMsg = '确定取消吗？'
        this.statName = '取消'
        this.dialogVisible = true
      }else if(command === 'e') {//启动流程
        this.$mask.open()

        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: {id: row.id, tableKey: "WkAssetTransfer", orgId: row.orgId, orderNo: row.billNo},
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
        })
      } else if (command === 'f') { //查看流程
        this.actPicUrl = `/act/wf/wfview/` + row.processId
        this.showPicDialog = true
      }
      this.$mask.close()

    },


    // 详情显示
    showInfo(row, $event) {
      this.openEditDialog(row, 'info')
    },

    // 新增/修改
    openEditDialog(row, type) {
      this.type = type
      this.dataId = !row.id || typeof row.id == 'object' ? 0 : row.id;
      this.processId=row.processId
      this.activeName = 'first';
      this.$openEditView('showEdit');
      console.log('触发了跳转');
    },

    gradeChange() {
      console.log(11, "11111111111");
      var objS = document.getElementById("pid");
      var grade = objS.options[objS.selectedIndex].grade;
      alert(grade);
      console.log(grade);
    },


    //导出
    doExcle(){
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.wkAssetTransfer).then(response => {
        if (response.data.type=="success"){
          doDownLoadExcle(api.wkAssetTransfer.doExcelUrl, this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
          this.$mask.close()
        }else{
          this.$mask.close()
          this.$message({
            type: response.data.type,
            message: response.data.content
          });
        }
      }).catch(() => {
        this.$mask.close()
      })
    },
    checkCommit(type){
      this.showCheckDialog = false;
      if (type == 1) {
        this.flushed()// 需要刷新页面
      }
    },

  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .screen-btns {
  // margin-bottom: 6px;
  border-bottom: 1px solid #ededed !important;
}

.vxe-grid .a-link {
  color: #00c4b3;
  margin-right: 0px !important;
}

// 弹窗过渡显示效果
// 进场时候过渡的开始状态和离场的结束状态
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 指定过渡的属性和时间，同样是进场和离场的过渡时间
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

// 进场时候过渡的结束状态和离场的开始状态
.fade-enter-to,
.fade-leave {
  opacity: 1;
}


// 选中的按钮

.goodsStatus {
  //按钮水平
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-content: space-between;
}

.btnGoodsStatusBt {
  //白底按钮
  // width: 100px;
  margin-right: 20px;
  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  text-align: center;
  background: #fff;
  padding: 5px;
}

.btnGoodsStatusBt1 {
  //红底按钮
  // width: 100px;
  margin-right: 20px;

  font-size: 14px;
  height: 30px;
  // border: 1px solid #eff0f7;
  line-height: 20px;
  color: #409eff;
  text-align: center;
  border-bottom: 3px solid #409eff;
  padding: 5px;
}

.num_color {
  display: inline-block;
  margin-left: 5px;
  /* width: 15px; */
  font-size: 12px;
  padding: 4px;
  line-height: 7px;
  height: 12px;
  color: #409eff;
  border-radius: 4px 4px;
  background-color: #ddeaff;
}

// 隐藏搜索框 标题的宽度
.vxe-grid .vxe-form--item .vxe-form--item-title .vxe-form--item-title-label {
  font-size: 12px;
  display: inline-block;
  width: 65px !important;
}


.active1 {
  // height: 100vh;
  height: calc(100vh - 77px);
  padding-bottom: 29px !important;
}

.no-active2 {
  height: calc(100vh - 70px);
  padding-bottom: 43px !important;
}

#avue-view {
  overflow: unset !important;
}

.avue-view {
  overflow: unset !important;

}

// ::v-deep .vxe-grid .vxe-pager {
//     font-size: 12px;
//     height: 25px !important;
// 	// overflow: hidden;
// }
::v-deep .el-collapse-item__wrap {
  will-change: height;
  background-color: #FFF;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: none !important;
}

::v-deep .el-collapse-item__header {
  height: 0px;
  line-height: 0px;
  border: none !important;
}

::v-deep .el-collapse-item__header.is-active {
  border-bottom: none;
}

::v-deep .el-collapse {
  border-top: 1px solid #002c93;
  border-bottom: 1px solid #EBEEF5;
  border: none;
}

::v-deep .el-collapse-item__arrow {
  position: relative;
  top: -140px;
  font-size: 18px;
  color: #0077ff;
}

::v-deep .vxe-grid .vxe-form--item-title .vxe-form--item-title-content {
  -webkit-box-flex: 1;
  display: inline-block;
  width: 55px;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

// 隐藏搜索栏
.screen-box {
  display: flex;


}

::v-deep .vxe-grid .vxe-form.screen-box {
  padding: 4px 10px 2px 0;
}


::v-deep .vxe-grid .el-input .el-input__inner {
  height: 28px !important;
}
</style>
